import { useQuery } from "@tanstack/react-query";
import {
  getCategories,
  getLimitProducts,
  getProduct,
  getProductsInCategory,
} from "./api";

export function useGetCategoriesQuery() {
  return useQuery({
    queryKey: ["categories"],
    queryFn: getCategories,
  });
}

export function useGetProductsInCollectionQuery(collection) {
  return useQuery({
    queryKey: ["productsCollection"],
    queryFn: async () => await getProductsInCategory(collection),
  });
}

export function useGetLimitProductsQuery(limit) {
  return useQuery({
    queryKey: ["productsLimit", `productsLimit-${limit}`],
    queryFn: async () => getLimitProducts(limit),
  });
}

export const useGetProductQuery = (id) => {
  return useQuery({
    queryKey: [`product-${id}`],
    queryFn: () => getProduct(id),
  });
};
